/**
 * @param {String} relativeUrl
 *
 * @returns {string}
 */
export default function apiUrl(relativeUrl) {
    return document.head.querySelector('meta[name="api-url"]').content + relativeUrl;
}
